import {CREATE_SHIFT, CREATE_SHIFT_FAILED, CREATE_SHIFT_SUCCESS, RECEIVE_SHIFTS, REQUEST_SHIFTS} from "../actionTypes";
import {API_ROOT} from "../../config";
import fetch from "cross-fetch";

function createShift(shift) {
  return {
    type: CREATE_SHIFT,
    shift: shift,
  }
}

function createShiftSuccess(shift) {
  return {
    type: CREATE_SHIFT_SUCCESS,
    shift: shift,
  }
}

function createShiftFailed(shift, error) {
  return {
    type: CREATE_SHIFT_FAILED,
    shift: shift,
    error: error,
  }
}

export function postShift(shift) {
  return dispatch => {
    dispatch(createShift(shift));
    return fetch(API_ROOT + '/shifts/', {
      method: 'POST',
      body: JSON.stringify(shift),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(
        response => response.json(),
        error => {
          console.log(error);
          dispatch(createShiftFailed(shift, error));
        }
      )
      .then(json => dispatch(createShiftSuccess(json)));
  }
}

function requestShifts(business) {
  return {
    type: REQUEST_SHIFTS,
    business: business
  }
}

function receiveShifts(shifts) {
  return {
    type: RECEIVE_SHIFTS,
    items: shifts
  }
}

export function fetchShifts(business) {
  return dispatch => {
    dispatch(requestShifts(business));
    return fetch(API_ROOT + '/businesses/' + business.id + '/shifts/')
      .then(response => response.json())
      .then(json => dispatch(receiveShifts(json)));
  }
}

export function fetchShiftsIfNeeded(business) {
  return (dispatch, getState) => {
    const state = getState();
    if (!state.shifts.items) {
      return dispatch(fetchShifts(business));
    }
  }
}


// WEBPACK FOOTER //
// ./src/state/actions/shifts.js